import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { map } from 'lodash/fp';
import { hexToRgb } from '../../common/utils';

const S = {
  Answers: styled.ul`
    margin-left: 8px;
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  `,
  AnswerItem: styled.li`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    background-color: ${({ theme }) => theme.palette.blueGrey[50]};
    :nth-child(even) {
      background-color: ${({ theme }) => hexToRgb(theme.palette.blueGrey[50], 0.5)};
    }
  `,
  Value: styled.p`
    max-width: 95%;
    word-break: break-all;
    word-wrap: break-word;
  `,
};

const DescriptiveAnswers = ({
  stats,
}) => {
  const data = useMemo(() => map.convert({ cap: false })((s, key) => ({
    name: key,
    value: s,
  }), stats), [stats]);

  return (
    <div>
      <S.Answers>
        {map(answer => (
          <S.AnswerItem key={answer.name}>
            <S.Value>{answer.name}</S.Value>
            <data value={answer.value}>{`${answer.value}명`}</data>
          </S.AnswerItem>
        ), data)}
      </S.Answers>
    </div>
  );
};

DescriptiveAnswers.propTypes = {
  stats: PropTypes.objectOf(PropTypes.number).isRequired,
};

export default DescriptiveAnswers;
